

export function timeStringToDate(timeStr) {
  try {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  } catch (err) {
    console.error('timeStringToDate error');
    return new Date();
  }
}
